import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockFullBleedImageData {
  url?: BlockComponentImage;
  backgroundImage?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockFullBleedImageData {
  export function make(url?: string, backgroundImage?: string): BlockFullBleedImageData {
    return {
      url: BlockComponentImage.make(url),
      backgroundImage: BlockComponentImage.make(backgroundImage),
    };
  }

  export function getDefault(url = ''): BlockFullBleedImageData {
    return make(url);
  }
}

export default BlockFullBleedImageData;
